export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY hh:mm a';
